import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/traeger/src/components/Footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/traeger/src/components/Modals/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/traeger/src/components/Navbar/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/traeger/src/components/Navigation/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/traeger/src/foundations/main.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/traeger/src/style/large-styles.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/traeger/src/style/medium-styles.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/traeger/src/style/mobile-styles.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/traeger/src/style/small-styles.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/traeger/src/style/xl-styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/traeger/src/theme/theme.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mui/material-nextjs/v13-appRouter/appRouterV13.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mui/material/styles/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/ui/src/context/BreadCrumbProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/ui/src/context/CurrentUrlProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InternalTranslationProvider"] */ "/vercel/path0/packages/ui/src/context/Translation/context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UIProvider"] */ "/vercel/path0/packages/ui/src/modules/UI/index.ts");
